import {
    useAppInsightsContext,
    useTrackEvent,
} from '@microsoft/applicationinsights-react-js';
import type { ReactNode } from 'react';

import { Checkbox } from '@myphx-engineering/phx-design-system';

import type { useSignUpForm } from '../../pages/sign-up/use-sign-up-form';

type CheckboxFieldProps = {
    form: ReturnType<typeof useSignUpForm>['form'];
    label?: ReactNode;
    page: string;
    field: string;
};
export const CheckboxField = ({
    form,
    label,
    page,
    field,
}: CheckboxFieldProps) => {
    const appInsights = useAppInsightsContext();
    const track = useTrackEvent(appInsights, `${page}_${field}_CLICK`, {});

    const inputProps = form.getInputProps(field);
    inputProps.onChange = () => {
        track({ message: `Checkbox field ${field} is clicked` });
        form.setFieldValue(field, !form.values[field]);
    };

    return <Checkbox label={label} {...inputProps} error={null} />;
};
